import React, { useState } from "react";
import SparkLine from "../sparkline/SparkLine";
import { SparkLineProps } from "../sparkline/SparkLineTypes";

export default function SparkLineAdvanced(props: SparkLineProps) {
  const [expandedChartIndex, setExpandedChartIndex] = useState<number>(
    props.generalProperties?.expandedChartIndex ?? 0
  );

  if (props.isMultipleCharts && !props.generalProperties?.chartsInOneBox) {
    return (
      <div className="flex flex-column gap-2">
        <SparkLine
          {...props}
          chartIndex={0}
          advanced
          isExpanded={expandedChartIndex === 0}
          setExpandedChartIndex={setExpandedChartIndex}
          generalProperties={props.generalProperties}
          isMultipleCharts
        />
        {props.multipleCharts.map((chart, index) => (
          <SparkLine
            key={chart.id ?? index}
            {...chart}
            chartIndex={index + 1}
            isExpanded={expandedChartIndex === index + 1}
            setExpandedChartIndex={setExpandedChartIndex}
            advanced
            generalProperties={props.generalProperties}
            isMultipleCharts
          />
        ))}
      </div>
    );
  }

  const getAllCharts = (): Record<number, string> | undefined => {
    if (!props.isMultipleCharts || !props.generalProperties?.chartsInOneBox) return undefined;
    const allCharts: Record<number, string> = { 0: props.chartTitle ?? "" };
    if (props.multipleCharts) {
      props.multipleCharts.forEach((chart, index) => {
        const title: string = chart.chartTitle ?? "";
        allCharts[index + 1] = title;
      });
    }
    return allCharts;
  };

  const getChart = () => {
    if (expandedChartIndex === 0) {
      return props;
    }
    const chartToReturn = {
      ...props.multipleCharts[expandedChartIndex - 1],
      multipleCharts: props.multipleCharts,
    };
    return chartToReturn;
  };
  return (
    <SparkLine
      {...getChart()}
      chartIndex={expandedChartIndex}
      allCharts={getAllCharts()}
      advanced
      setExpandedChartIndex={setExpandedChartIndex}
      isExpanded
      generalProperties={props.generalProperties}
      isMultipleCharts={props.isMultipleCharts && props.multipleCharts.length > 1}
    />
  );
}
